module.exports = __webpack_public_path__ + "public/files/img/mechanic.aa66419e.png";